<template>
  <b-modal :modelValue="deal !== null"
           header-class="d-none"
           footer-class=" d-flex justify-content-between"
           @update:modelValue="$event === false && (deal = null)">
    <template #default>

      <div class="row">
        <div class="col-sm-12">
            <DatePicker v-model="form.date" mode="dateTime" :model-modifiers="{string: true}" is24hr :masks="{modelValue: 'YYYY-MM-DD HH:mm:ss', inputDateTime24hr: 'YYYY-MM-DD HH:mm:ss'}">
              <template v-slot="{ inputValue, togglePopover, inputEvents }">
                <input
                  class="form-control "
                  :placeholder="helper.trans('labels.expire_at')"
                  :value="dateHelper.isIndefiniteSuspend(form.date) ? helper.trans('labels.indefinitely') : inputValue"
                  @focus="togglePopover"
                  @change="inputEvents.change"
                />
              </template>
            </DatePicker>
        </div>
      </div>
      <div class="row mt-2">
        <div class="col-sm-12">
          <button v-for="hour in [1,6,24,72]" :key="hour" @click.prevent="selectPeriod(hour)" type="button" class="btn btn-sm btn-outline-secondary me-2">
            {{helper.trans('labels.hours_period', {hour})}}
          </button>
          <button @click.prevent="selectInfinity" type="button" class="btn btn-sm btn-outline-secondary me-2">
            &#8734;
          </button>
        </div>
      </div>

      <div class="row mt-4">
        <div class="col-sm-12">
          <input type="text" class="form-control" v-model="form.comment" :placeholder="helper.trans('labels.comment')">
        </div>
      </div>

    </template>
    <template #footer>
      <button type="button" @click="deal = null" class="btn btn-outline-dark btn-sm text-capitalize-first">
        {{  helper.trans('button.cancel')  }}
      </button>

      <LoaderWrapper ref="loader" :zoom="0.5">
        <button type="button" @click="onOkClick()" class="btn btn-outline-danger btn-sm text-capitalize-first">
          {{ helper.trans('button.ok') }}
        </button>
      </LoaderWrapper>

    </template>
  </b-modal>
</template>

<script lang="ts">

import {defineComponent, ref} from 'vue'
import {reactive, toRefs} from "@vue/reactivity";
import {BModal} from "bootstrap-vue-3";
import LoaderWrapper from "@/components/LoaderWrapper.vue";
import {helper} from "@/service/CommonHelper";
import ExtendedDealDTO from "@/models/ExtendedDealDTO";
import {DatePicker} from "v-calendar";
import moment from 'moment-timezone';
import {dateHelper} from "@/service/DateHelper";

export default defineComponent({
  components: {
    DatePicker,
    BModal,
    LoaderWrapper
  },
  setup() {
    const loader = ref<InstanceType<typeof LoaderWrapper> | null>(null)

    const state = reactive({
      deal: null as ExtendedDealDTO|null,
      onOkClick: null as any,
      form: {
        date: null as string|null,
        comment: null as string|null,
      }
    });

    const show = (deal: ExtendedDealDTO, onOkClick: any) => {
      state.deal = deal
      state.onOkClick = onOkClick;
      state.form.date = null
      state.form.comment = null
    }

    const onOkClick = async () => {
      if (!state.deal) {
        return;
      }

      loader.value?.show()
      try {
        await state.onOkClick({
          ...state.form,
          date: dateHelper.toUTC(state.form.date)
        })
      } finally {
        loader.value?.hide()
      }

      state.deal = null;
    }

    const selectPeriod = (hour: number) => {
      state.form.date = moment().tz(dateHelper.getUserTimeZone()).add(hour, 'hour').format('YYYY-MM-DD HH:mm:ss')
    }

    const selectInfinity = () => {
      state.form.date = moment().tz(dateHelper.getUserTimeZone()).add(4, 'year').format('YYYY-MM-DD HH:mm:ss')
    }

    return {
      ...toRefs(state),
      selectPeriod,
      selectInfinity,
      onOkClick,
      show,
      loader,
      helper,
      dateHelper
    }
  }
})
</script>
